// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__bBzCR","unreadBadge":"styles_unreadBadge__3O52v","modalContent":"styles_modalContent__2g3qt","modal":"styles_modal__3gL2I"};